import * as lenis from './lenis'

export default el => {
	const name = el.dataset.conditionalContentName;
	const value = el.dataset.conditionalContentValue;

	const inputs = document.querySelectorAll(`input[name="${name}"]`);

	if (!inputs) return;

	inputs.forEach(input => {
		input.addEventListener('change', () => {
			update(input);
		})
	})

	const update = (input = false) => {
		if (!input) input = document.querySelector(`input[name="${name}"]:checked`);

		if (!input || !input.checked || !value.includes(input.value)) {
			el.style.display = 'none';
		}

		else {
			el.style.removeProperty('display');
		}

		lenis.resize();
	}

	update();
};
